import useContextWithErrorHandler from '@lwtears/lwt-common-frontend/lib/@common/hooks/use-context-with-error-handler';
import { HintContext } from '../providers/HintProvider';
import { UseHint } from '../providers/HintProvider/types';

const useHint = (): UseHint => {
  const [state, dispatch] = useContextWithErrorHandler(HintContext, 'HintProvider');

  return [state, dispatch];
};

export default useHint;
